export default __webpack_public_path__ + "static/media/about-sec-imgs.bd3315ad.jpg";